import { env } from '@/env';

export function playerPageUri(playerUUID: string) {
  return `${env.flightdeck.uri}/players/${playerUUID}/by_uuid`;
}

export function hawkeyePlayerPageUri(playerUUID: string) {
  return `${env.hawkeye.uri}/players/${playerUUID}`;
}

export function eventPageUri(eventId: string) {
  return `${env.hawkeye.uri}/events/${eventId}`;
}

export function sportsBetPageUri(betId: string | number) {
  return `${env.hawkeye.uri}/sports-bet/${betId}`;
}
